import type { Movie } from "@/types";

export const MOVIE_DISCLAIMER =
  "本页面所有影视作品、评分、剧照、人物信息均为虚构演示数据，仅用于界面展示，不代表任何真实作品。";

export const GENRES = [
  "动作",
  "爱情",
  "科幻",
  "悬疑",
  "剧情",
  "犯罪",
  "古装",
  "喜剧",
  "奇幻",
  "冒险",
  "都市",
  "历史",
  "家庭",
  "青春",
  "谍战",
  "惊悚",
];

export const REGIONS = ["国产", "港台", "欧美", "日韩"];

export const YEARS = ["2025", "2024", "2023", "2022", "2021"];

export const SORT_OPTIONS = [
  { value: "latest", label: "最新" },
  { value: "hot", label: "热门" },
  { value: "rating", label: "评分" },
];

export const movies: Movie[] = [
  {
    id: "changye-jiangming",
    title: "长夜将明",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20lone%20astronomer%20standing%20before%20a%20colossal%20glowing%20eclipse%20over%20a%20futuristic%20city%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-01&orientation=portrait",
    year: 2025,
    rating: 8.9,
    genres: ["科幻", "悬疑", "剧情"],
    region: "国产",
    director: "沈之远",
    actors: ["陆时年", "苏晚晴", "周砚"],
    releaseDate: "2025-10-01",
    duration: "138分钟",
    summary:
      "近未来世界，一场持续三百年的长夜降临大地。天文学家陆时年发现，唯一能唤回太阳的答案，藏在被遗忘的旧观测档案里。当他踏上寻找真相的旅程，才发现真正需要被照亮的，是人类自己。",
    tags: ["科幻", "高智商", "视觉大片", "国产佳作"],
    featured: true,
  },
  {
    id: "shanhe-gurenlu",
    title: "山河故人录",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20weathered%20traveler%20gazing%20across%20vast%20misty%20mountains%20at%20golden%20dawn%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-02&orientation=portrait",
    year: 2024,
    rating: 8.5,
    genres: ["剧情", "历史", "家庭"],
    region: "国产",
    director: "沈之远",
    actors: ["何长风", "林素珍", "张小满"],
    releaseDate: "2024-05-18",
    duration: "152分钟",
    summary:
      "从一座北方小城出发，一家三代人在半个世纪里的离散与重逢。影片以一封封未曾寄出的家书为线索，记录了普通人在时代洪流中的坚持与温柔，写给所有漂泊过、也牵挂过的人。",
    tags: ["剧情", "催泪", "年代", "口碑佳作"],
  },
  {
    id: "zhuifengzhe",
    title: "追风者",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20motorcycle%20rider%20speeding%20through%20rain%20soaked%20neon%20city%20streets%20at%20night%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-03&orientation=portrait",
    year: 2025,
    rating: 8.2,
    genres: ["动作", "犯罪"],
    region: "国产",
    director: "郑铁",
    actors: ["高野", "秦霜", "马天行"],
    releaseDate: "2025-07-12",
    duration: "126分钟",
    summary:
      "退役赛车手高野为了替兄弟洗清冤屈，重新卷入地下飙车与走私的漩涡。每一次油门到底，都是在和命运抢时间。速度与正义之间，他只剩下一个选择。",
    tags: ["动作", "赛车", "爽片", "荷尔蒙"],
  },
  {
    id: "chunchao-haian",
    title: "春潮海岸",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20young%20couple%20walking%20along%20a%20quiet%20shoreline%20under%20a%20soft%20sunset%20glow%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-04&orientation=portrait",
    year: 2023,
    rating: 8.0,
    genres: ["爱情", "剧情"],
    region: "国产",
    director: "顾清欢",
    actors: ["苏晚晴", "江屿", "白露"],
    releaseDate: "2023-09-15",
    duration: "118分钟",
    summary:
      "在海边小城经营旧书店的女孩，遇见了一位每年春天都会来住一个月的画家。两个从不同世界来的人，用一整个春天的潮汐，学会如何告别，也学会如何留下。",
    tags: ["爱情", "文艺", "治愈", "海边"],
  },
  {
    id: "xingji-huixiang",
    title: "星际回响",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20massive%20starship%20drifting%20before%20a%20swirling%20galaxy%20and%20distant%20alien%20planet%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-05&orientation=portrait",
    year: 2025,
    rating: 9.0,
    genres: ["科幻", "冒险"],
    region: "欧美",
    director: "Elias Vance",
    actors: ["Marcus Reed", "Ivy Sinclair", "Noah Grange"],
    releaseDate: "2025-06-20",
    duration: "156分钟",
    summary:
      "一支深空探索队在远离地球的星域收到了一段重复了千年的信号。当队长艾薇决定回应它，人类第一次意识到，宇宙的回响里，藏着关于孤独与勇气的终极答案。",
    tags: ["科幻", "太空", "史诗", "IMAX"],
    featured: true,
  },
  {
    id: "anye-zhuixiong",
    title: "暗夜追凶",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20detective%20silhouette%20under%20a%20single%20streetlamp%20in%20heavy%20fog%20and%20rain%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-06&orientation=portrait",
    year: 2024,
    rating: 8.6,
    genres: ["悬疑", "惊悚", "犯罪"],
    region: "欧美",
    director: "Elias Vance",
    actors: ["Marcus Reed", "Sofia Hale", "Leo Brandt"],
    releaseDate: "2024-11-08",
    duration: "132分钟",
    summary:
      "雨夜、旧案、消失的目击者。退休警探马库斯被一桩尘封十五年的失踪案重新拉回战场，越是接近真相，他越发现凶手或许一直就站在自己身后。",
    tags: ["悬疑", "烧脑", "反转", "犯罪"],
  },
  {
    id: "zuihou-lüren",
    title: "最后的旅人",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20solitary%20figure%20with%20a%20backpack%20on%20an%20endless%20desert%20highway%20at%20dusk%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-07&orientation=portrait",
    year: 2023,
    rating: 7.9,
    genres: ["剧情", "冒险"],
    region: "欧美",
    director: "Hannah Cole",
    actors: ["Noah Grange", "Emma Frost"],
    releaseDate: "2023-03-24",
    duration: "121分钟",
    summary:
      "一辆抛锚的旧皮卡、一条望不到头的公路、一个不肯回头的男人。他把所有行李都留在了过去，却始终没能把记忆一起扔掉。这是一场关于放下的公路旅行。",
    tags: ["剧情", "公路", "治愈", "人生"],
  },
  {
    id: "guigu-fengyun",
    title: "硅谷风云",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20modern%20glass%20office%20tower%20reflected%20in%20a%20rainy%20city%20window%20at%20blue%20hour%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-08&orientation=portrait",
    year: 2024,
    rating: 8.3,
    genres: ["剧情", "传记"],
    region: "欧美",
    director: "Hannah Cole",
    actors: ["Leo Brandt", "Ivy Sinclair", "Marcus Reed"],
    releaseDate: "2024-08-30",
    duration: "144分钟",
    summary:
      "从车库创业到千亿市值，一家科技公司用了十年。影片以两位创始人的友谊与决裂为切口，讲述野心、信任与代价如何在代码之外慢慢改写人生。",
    tags: ["剧情", "创业", "商业", "传记"],
  },
  {
    id: "yinghua-zhiyue",
    title: "樱花之约",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20two%20students%20under%20blooming%20cherry%20blossom%20trees%20in%20soft%20spring%20light%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-09&orientation=portrait",
    year: 2022,
    rating: 8.1,
    genres: ["爱情", "青春"],
    region: "日韩",
    director: "中村遥",
    actors: ["佐藤琴", "木下阳光"],
    releaseDate: "2022-04-02",
    duration: "112分钟",
    summary:
      "每一年樱花盛开的那一周，他们都会在同一棵树下许下一个约定。从高中到成年，从相见走到了错过，一句始终没说出口的话，等了整整十年。",
    tags: ["爱情", "青春", "催泪", "日系"],
  },
  {
    id: "wudu-mian",
    title: "雾都谜案",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20vintage%20clock%20tower%20rising%20above%20a%20foggy%20victorian%20street%20at%20night%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-10&orientation=portrait",
    year: 2022,
    rating: 8.4,
    genres: ["犯罪", "悬疑"],
    region: "欧美",
    director: "Sofia Hale",
    actors: ["Leo Brandt", "Emma Frost", "Noah Grange"],
    releaseDate: "2022-12-16",
    duration: "129分钟",
    summary:
      "维多利亚时代的雾都，一名私人侦探接手了一起看似普通的失窃案，却一步步揭开整座城市被精心掩盖的秘密。真相像雾一样，越靠近越看不清。",
    tags: ["悬疑", "复古", "推理", "英伦"],
  },
  {
    id: "gangdao-miqing",
    title: "港岛迷情",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20two%20cars%20chasing%20through%20a%20dense%20neon%20lit%20harbor%20city%20at%20midnight%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-11&orientation=portrait",
    year: 2024,
    rating: 8.0,
    genres: ["动作", "犯罪"],
    region: "港台",
    director: "陈家豪",
    actors: ["梁子健", "何静怡", "邓世昌"],
    releaseDate: "2024-02-10",
    duration: "124分钟",
    summary:
      "卧底警探阿健在帮派里潜伏了五年，只差一步就能收网，却在最后一夜遇见了同样被困其中的女孩。正义与情义，在霓虹与海浪之间只能二选一。",
    tags: ["动作", "警匪", "港风", "卧底"],
  },
  {
    id: "daoyu-laixin",
    title: "岛屿来信",
    type: "movie",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20small%20wooden%20boat%20near%20a%20quiet%20island%20coastline%20under%20a%20lavender%20sky%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-12&orientation=portrait",
    year: 2023,
    rating: 7.8,
    genres: ["剧情", "家庭"],
    region: "港台",
    director: "陈家豪",
    actors: ["何静怡", "陈伯远"],
    releaseDate: "2023-06-09",
    duration: "108分钟",
    summary:
      "岛上唯一的邮差退休那天，收到了一封寄给自己、却迟到了四十年的信。他决定划着小船，把信送回当年那个人的家门口，也把一段被海洋隔开的往事重新接上。",
    tags: ["剧情", "温情", "小岛", "治愈"],
  },
  {
    id: "changan-shiershi",
    title: "长安十二时",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20ancient%20chinese%20city%20walls%20and%20lantern%20lit%20streets%20at%20night%20with%20a%20lone%20guard%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-13&orientation=portrait",
    year: 2025,
    rating: 9.1,
    genres: ["古装", "悬疑", "历史"],
    region: "国产",
    director: "顾清欢",
    actors: ["何长风", "苏晚晴", "周砚", "白露"],
    releaseDate: "2025-03-01",
    duration: "共40集",
    summary:
      "上元节前夜，长安城陷入一场精心策划的阴谋。一名不得志的小吏与一位女捕快，必须在十二个时辰内找出真凶，拯救整座城池。时间在走，真相在暗处燃烧。",
    tags: ["古装", "悬疑", "群像", "神剧"],
    featured: true,
  },
  {
    id: "dushi-fushengji",
    title: "都市浮生记",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20modern%20glass%20skyscraper%20skyline%20at%20dusk%20reflected%20over%20a%20calm%20river%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-14&orientation=portrait",
    year: 2024,
    rating: 8.2,
    genres: ["都市", "爱情"],
    region: "国产",
    director: "郑铁",
    actors: ["秦霜", "陆时年", "林素珍"],
    releaseDate: "2024-09-06",
    duration: "共36集",
    summary:
      "四个合租在一间老公寓的年轻人，各自怀揣着不甘与梦想。加班的深夜、退租的清晨、还有那句总也说不出口的喜欢，构成了这座城市最真实的浮生百态。",
    tags: ["都市", "情感", "群像", "治愈"],
  },
  {
    id: "poxiao-xingdong",
    title: "破晓行动",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20wartime%20agent%20standing%20in%20a%20dim%20archive%20room%20lit%20by%20a%20single%20window%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-15&orientation=portrait",
    year: 2023,
    rating: 8.7,
    genres: ["谍战", "历史", "剧情"],
    region: "国产",
    director: "沈之远",
    actors: ["周砚", "白露", "张小满"],
    releaseDate: "2023-11-20",
    duration: "共42集",
    summary:
      "1944年的上海，一份关乎数万人命运的情报掌握在一个看似柔弱的女教师手中。她与战友们在天亮之前，必须完成一次几乎不可能的行动。黎明之前，最考验人心。",
    tags: ["谍战", "年代", "烧脑", "实力派"],
  },
  {
    id: "quanyou-xinjiyuan",
    title: "权游新纪元",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20towering%20fantasy%20castle%20on%20a%20cliff%20above%20stormy%20seas%20and%20dragons%20in%20the%20sky%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-16&orientation=portrait",
    year: 2025,
    rating: 9.2,
    genres: ["奇幻", "冒险", "剧情"],
    region: "欧美",
    director: "Elias Vance",
    actors: ["Ivy Sinclair", "Marcus Reed", "Sofia Hale", "Noah Grange"],
    releaseDate: "2025-04-14",
    duration: "共50集",
    summary:
      "旧王座陨落后的第一个寒冬，七大领地在新秩序的边缘蠢蠢欲动。一个不愿继承家名的私生子、一位背负预言的女祭司，将决定整个大陆的走向。史诗仍在续写。",
    tags: ["奇幻", "史诗", "大制作", "现象级"],
    featured: true,
  },
  {
    id: "manhattan-zhenshi",
    title: "曼哈顿诊室",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20bright%20hospital%20corridor%20at%20night%20with%20light%20streaming%20through%20tall%20windows%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-17&orientation=portrait",
    year: 2024,
    rating: 8.5,
    genres: ["剧情", "都市"],
    region: "欧美",
    director: "Hannah Cole",
    actors: ["Sofia Hale", "Leo Brandt"],
    releaseDate: "2024-01-19",
    duration: "共32集",
    summary:
      "曼哈顿一家急诊室里，每天都在上演最真实的生死时速。新来的住院医生带着理想主义闯入这个高压世界，逐渐明白医术之外，还有更难治愈的人心。",
    tags: ["剧情", "医疗", "职业", "成长"],
  },
  {
    id: "shouer-lianai",
    title: "首尔恋爱公式",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20cozy%20seoul%20cafe%20street%20in%20autumn%20with%20warm%20streetlights%20and%20falling%20leaves%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-18&orientation=portrait",
    year: 2025,
    rating: 8.0,
    genres: ["爱情", "喜剧"],
    region: "日韩",
    director: "金成勋",
    actors: ["朴智恩", "李在容", "崔秀彬"],
    releaseDate: "2025-05-08",
    duration: "共16集",
    summary:
      "一个坚信恋爱可以靠公式计算的数学老师，遇见了一个把人生过成随机数的吉他手。当理性撞上心动，所有精心推导的答案都开始失灵。轻盈又治愈的都市童话。",
    tags: ["爱情", "喜剧", "甜宠", "治愈"],
  },
  {
    id: "dongjing-mianbu",
    title: "东京谜案簿",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20rainy%20tokyo%20alley%20with%20a%20lone%20umbrella%20under%20glowing%20paper%20lanterns%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-19&orientation=portrait",
    year: 2023,
    rating: 8.6,
    genres: ["悬疑", "犯罪"],
    region: "日韩",
    director: "中村遥",
    actors: ["佐藤琴", "木下阳光", "小林まどか"],
    releaseDate: "2023-10-13",
    duration: "共24集",
    summary:
      "每一集都是一个独立的东京谜案，从深夜便利店到废弃铁道，普通人的日常里藏着最不普通的秘密。一个记性极差却推理惊人的侦探，用一本旧笔记串起所有真相。",
    tags: ["悬疑", "推理", "单元剧", "日系"],
  },
  {
    id: "taibei-yeweimian",
    title: "台北夜未眠",
    type: "tv",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20key%20art%20of%20a%20neon%20lit%20taipei%20night%20market%20street%20bustling%20with%20warm%20glowing%20signs%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20orange%20color%20grade%2C%20atmospheric%20haze%2C%20premium%20film%20marketing%20visual%2C%20minimalist%20composition%2C%20generous%20negative%20space%2C%20highly%20detailed&width=600&height=900&seq=movie-20&orientation=portrait",
    year: 2022,
    rating: 8.1,
    genres: ["都市", "剧情"],
    region: "港台",
    director: "陈家豪",
    actors: ["梁子健", "何静怡"],
    releaseDate: "2022-08-27",
    duration: "共28集",
    summary:
      "五个在台北夜市摆摊的年轻人，白天各有各的挣扎，夜晚却在烟火气里彼此取暖。城市不眠，他们的故事也没有结局，只有一个个继续前行的深夜。",
    tags: ["都市", "群像", "烟火气", "治愈"],
  },
];

export const featuredMovies = movies.filter((m) => m.featured);